import { FormErrors, SubmissionError } from 'redux-form'
import set from 'lodash/fp/set'
import { i18next } from 'app-support/contexts/I18nContext'

interface IError<T> {
  response: {
    data: T
  }
}

interface ValidationError {
  ErrorMessage: string
  ErrorType: string
  FieldName: string
  OriginalValue: any
}

interface IValidationError extends IError<{ ValidationErrors: ValidationError[] }> {}

class ValidationError extends SubmissionError {
  /**
   * We're extending Redux-Form's submission error with `unformattedErrors`. We need
   * this property for so we can translate validation errors properly when
   * using Formik.
   */
  constructor(errors: FormErrors<any, any>, public unformattedErrors: ValidationError[]) {
    super(errors)
  }
}

const validationError = ({ error }: { error: IValidationError }) => {
  const errors = error.response.data.ValidationErrors

  const validationErrors = errors.reduce((prev, curr) => {
    const hasGlobalTranslation = i18next.exists(`global.${curr.ErrorType}`)
    const hasCustomTranslation = i18next.exists(curr.ErrorType)
    let error = curr.ErrorType

    if (hasGlobalTranslation) {
      error = i18next.t(`global.${curr.ErrorType}`)
    } else if (hasCustomTranslation) {
      error = i18next.t(curr.ErrorType)
    }

    return set(curr.FieldName, error, prev)
  }, {})

  return new ValidationError(validationErrors, errors)
}

export default validationError
